var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[(!_vm.readonly)?[_c('a-select',{attrs:{"value":_vm.val},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(item){return _c('a-select-option',{key:item.value,attrs:{"value":item.value}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)]:[_c('div',[_vm._v(" ddd ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }